/* Publish by EComposer at 2026-09-16 15:27:32*/
;try{
 /* ======================================================
   Hardened Multi-step Form Validation (Global-grade)
   - Deterministic submit blocking
   - No Unicode regex escapes (compatible everywhere)
   - Defensive toggling normalization before *every* validation
   - Strict submit mode validates intended required set
   - Scopes all selectors to the form
   - Guards third-party libs (intl-tel-input) & async fetch
   - Sends data via FormData (multipart) so file upload works
   - State label shows "*" only when required
   - ONLINE pattern is hard-locked and mutation-guarded
   - Supports page-level config via window.registrationConfig
   - Uses list-based config fields: hideFields / optionalFields / lockFields
   - Keeps current behavior as fallback defaults
   ====================================================== */
// ---- No-op globals kept for compatibility with existing calls ----
window.syncNavButtons = function(){};
function pulse(){}
console.log("hello");

// ========= READY HELPERS =========
function onReady(fn) {
  if (document.readyState === "complete" || document.readyState === "interactive") {
    setTimeout(fn, 0);
  } else {
    document.addEventListener("DOMContentLoaded", fn, { once: true });
  }
}

// ========= STATE =========
let steps = [];
let nextBtns = [];
let prevBtns = [];
let form = null;
let currentStep = 0;

// ========= PAGE CONFIG =========
const DEFAULT_REGISTRATION_CONFIG = {
  heading: "Apply for a CellCore & Biocidin Botanicals Professional Account Today",
  subheading: "Your Patients Don’t Just Want Health. They Want Vitality",
  heroImageUrl: "https://res.cloudinary.com/microbe/image/upload/v1759781155/stock/iStock-1434212178.jpg",
  heroImageAlt: "Registration illustration",
  successRedirectUrl: "",
  campaignCode: "",
  sourceDefault: "",
  sourceDescriptionDefault: "",
  brandDefault: "",
  tags: [],
  hideFields: [],
  optionalFields: [],
  lockFields: []
};

function normalizeConfigList(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (typeof value === "string" && value.trim()) return [value.trim()];
  return [];
}

function getRegistrationConfig() {
  const incoming = window.registrationConfig || {};
  return {
    ...DEFAULT_REGISTRATION_CONFIG,
    ...incoming,
    tags: normalizeConfigList(incoming.tags),
    hideFields: normalizeConfigList(incoming.hideFields),
    optionalFields: normalizeConfigList(incoming.optionalFields),
    lockFields: normalizeConfigList(incoming.lockFields)
  };
}

let pageConfig = getRegistrationConfig();

// ======== STATE MAPS ========
const STATE_MAPS = {
  us: {
    AL:"Alabama", AK:"Alaska", AZ:"Arizona", AR:"Arkansas", CA:"California",
    CO:"Colorado", CT:"Connecticut", DE:"Delaware", DC:"District of Columbia",
    FL:"Florida", GA:"Georgia", HI:"Hawaii", ID:"Idaho", IL:"Illinois",
    IN:"Indiana", IA:"Iowa", KS:"Kansas", KY:"Kentucky", LA:"Louisiana",
    ME:"Maine", MD:"Maryland", MA:"Massachusetts", MI:"Michigan",
    MN:"Minnesota", MS:"Mississippi", MO:"Missouri", MT:"Montana",
    NE:"Nebraska", NV:"Nevada", NH:"New Hampshire", NJ:"New Jersey",
    NM:"New Mexico", NY:"New York", NC:"North Carolina", ND:"North Dakota",
    OH:"Ohio", OK:"Oklahoma", OR:"Oregon", PA:"Pennsylvania",
    RI:"Rhode Island", SC:"South Carolina", SD:"South Dakota",
    TN:"Tennessee", TX:"Texas", UT:"Utah", VT:"Vermont", VA:"Virginia",
    WA:"Washington", WV:"West Virginia", WI:"Wisconsin", WY:"Wyoming",
    PR:"Puerto Rico", VI:"U.S. Virgin Islands", GU:"Guam",
    MP:"Northern Mariana Islands", AS:"American Samoa"
  },
  ca: {
    AB:"Alberta", BC:"British Columbia", MB:"Manitoba", NB:"New Brunswick",
    NL:"Newfoundland and Labrador", NS:"Nova Scotia", NT:"Northwest Territories",
    NU:"Nunavut", ON:"Ontario", PE:"Prince Edward Island", QC:"Quebec",
    SK:"Saskatchewan", YT:"Yukon"
  },
  au: {
    ACT:"Australian Capital Territory", NSW:"New South Wales",
    NT:"Northern Territory", QLD:"Queensland", SA:"South Australia",
    TAS:"Tasmania", VIC:"Victoria", WA:"Western Australia"
  }
};

function codeToFullState(countryValue, stateValue) {
  const c = normCountry(countryValue);
  const code = (stateValue || "").trim().toUpperCase();
  const map = STATE_MAPS[c];
  if (!map) return stateValue;
  return map[code] || stateValue;
}

// store phone input instances for E.164 serialization
const phoneInstances = new Map();

// ========= SAFE HELPERS =========
function withinForm(selector) {
  return form ? Array.from(form.querySelectorAll(selector)) : [];
}
function isVisible(el) {
  if (!el) return false;
  const style = window.getComputedStyle(el);
  if (style.visibility === "hidden" || style.display === "none") return false;
  if (el.closest("[hidden]")) return false;
  return el.offsetParent !== null || el === document.activeElement;
}
function isInteractive(el) { return !!el && isVisible(el) && !el.disabled; }

function getErrorWrapper(input) {
  if (!input) return null;
  const iti = input.closest?.(".iti");
  if (iti && iti.parentElement) return iti.parentElement;
  if (input.type === "file") {
    return (
      input.closest(".cert_wrapper") ||
      input.closest(".input-group") ||
      input.closest("div") ||
      input.parentElement ||
      input
    );
  }
  return input.closest("div") || input.parentElement || input;
}

function setFieldError(input, message) {
  const wrapper = getErrorWrapper(input) || input;
  wrapper.classList.add("field-error");
  if (input) input.setAttribute("aria-invalid", "true");

  let msg = wrapper.querySelector(".error-msg");
  if (!msg) {
    msg = document.createElement("small");
    msg.className = "error-msg";
    wrapper.appendChild(msg);
  }
  msg.textContent = message || "Please correct this field.";

  if (input) {
    if (!msg.id) msg.id = `${input.id || input.name || "field"}-err`;
    const ids = new Set((input.getAttribute("aria-describedby") || "").split(/\s+/).filter(Boolean));
    ids.add(msg.id);
    input.setAttribute("aria-describedby", Array.from(ids).join(" "));
  }
}
function clearFieldError(input) {
  const wrapper = getErrorWrapper(input) || input;
  wrapper.classList.remove("field-error");
  if (input) input.removeAttribute("aria-invalid");

  const msg = wrapper.querySelector(".error-msg");
  if (msg) msg.remove();

  if (input) {
    const describedby = (input.getAttribute("aria-describedby") || "").split(/\s+/).filter(Boolean);
    const kept = describedby.filter(id => !id.endsWith("-err"));
    if (kept.length) input.setAttribute("aria-describedby", kept.join(" "));
    else input.removeAttribute("aria-describedby");
  }
}

const DEFAULT_MESSAGES = {
  required:  (el) => el?.dataset?.msgRequired  || "This field is required.",
  email:     (el) => el?.dataset?.msgEmail     || "Please enter a valid email address.",
  pattern:   (el) => el?.dataset?.msgPattern   || "Please match the requested format.",
  minlength: (el) => el?.dataset?.msgMinlength || `Please enter at least ${el.minLength} characters.`,
  select:    (el) => el?.dataset?.msgSelect    || "Please select an option."
};

// ========= CONFIG FIELD MAP =========
const CONFIG_FIELD_MAP = {
  prefix: ".prefix_wrapper",
  firstName: ".fName_wrapper",
  lastName: ".lName_wrapper",
  email: ".email_wrapper",
  business: ".business_wrapper",
  phone: ".phone_wrapper",
  mobile: "#mobile",
  npi: ".npi_wrapper",
  npiNumber: "#npi-number-group",
  profession: "#profession-group",
  file: "#cert-group",
  online: ".online_wrapper",
  brands: ".brand_wrapper",
  avgPatients: ".avg_wrapper",
  numPractitioners: ".num-prac_wrapper",
  interest: ".interest_wrapper",
  supplement: ".supplements_wrapper",
  source: "#source",
  sourceDescription: "#source_description",
  practiceType: ".practice_wrapper",
  country: "#country-group",
  state: "#state-group",
  city: "#city-group",
  street: "#street-group",
  zip: "#zip-group"
};

function getConfigTarget(key) {
  const selector = CONFIG_FIELD_MAP[key];
  if (!selector || !form) return null;
  return form.querySelector(selector);
}

function rememberOriginalRequirements(el) {
  if (!el) return;
  if (!el.hasAttribute("data-original-required")) {
    el.setAttribute("data-original-required", el.required ? "true" : "false");
  }
}

function restoreOriginalRequirements(el) {
  if (!el) return;
  const original = el.getAttribute("data-original-required");
  if (original === "true") el.required = true;
  if (original === "false") el.required = false;
}

function clearControlValue(el) {
  if (!el) return;

  if (el.type === "checkbox" || el.type === "radio") {
    el.checked = false;
  } else if (el.type === "file") {
    try { el.value = ""; } catch {}
    const certText = form?.querySelector(".filetext");
    const certOver = form?.querySelector(".validate__file--over");
    if (certText) certText.value = "";
    if (certOver) certOver.hidden = true;
  } else if (el.tagName === "SELECT") {
    el.selectedIndex = 0;
  } else {
    el.value = "";
  }

  el.setCustomValidity("");
  clearFieldError(el);
}

function hideConfiguredTarget(target) {
  if (!target) return;

  target.hidden = true;
  target.setAttribute("data-config-hidden", "true");

  const controls = target.matches("input, select, textarea")
    ? [target]
    : Array.from(target.querySelectorAll("input, select, textarea"));

  controls.forEach((el) => {
    rememberOriginalRequirements(el);
    el.disabled = true;
    el.required = false;
    clearControlValue(el);
    if (el.id === "state") setRequiredAsterisk(el, false);
  });
}

function makeConfiguredTargetOptional(target) {
  if (!target) return;

  const controls = target.matches("input, select, textarea")
    ? [target]
    : Array.from(target.querySelectorAll("input, select, textarea"));

  controls.forEach((el) => {
    rememberOriginalRequirements(el);
    el.required = false;
    el.setCustomValidity("");
    clearFieldError(el);
    if (el.id === "state") setRequiredAsterisk(el, false);
  });
}

function unhideConfiguredTarget(target) {
  if (!target) return;

  if (target.getAttribute("data-config-hidden") === "true") {
    target.hidden = false;
    target.removeAttribute("data-config-hidden");
  }

  const controls = target.matches("input, select, textarea")
    ? [target]
    : Array.from(target.querySelectorAll("input, select, textarea"));

controls.forEach((el) => {
  el.disabled = false;
  restoreOriginalRequirements(el);
  el.readOnly = false;
  el.removeAttribute("data-config-locked");
  el.removeAttribute("aria-disabled");
  el.removeAttribute("data-locked-value");

  if (el.tagName === "SELECT") {
    el.style.pointerEvents = "";
    el.tabIndex = 0;
  }

  if (el.id === "state") setRequiredAsterisk(el, el.required);
});
}

function resetConfiguredEffects() {
  if (!form) return;

  Object.values(CONFIG_FIELD_MAP).forEach((selector) => {
    const target = form.querySelector(selector);
    if (!target) return;
    unhideConfiguredTarget(target);
  });
}

function applyConfiguredRules() {
  if (!form) return;

  resetConfiguredEffects();

  const hideList = normalizeConfigList(pageConfig?.hideFields);
  const optionalList = normalizeConfigList(pageConfig?.optionalFields);
  const lockList = normalizeConfigList(pageConfig?.lockFields);

  hideList.forEach((key) => {
    const target = getConfigTarget(key);
    hideConfiguredTarget(target);
  });

  optionalList.forEach((key) => {
    const target = getConfigTarget(key);
    if (!target || target.getAttribute("data-config-hidden") === "true") return;
    makeConfiguredTargetOptional(target);
  });

lockList.forEach((key) => {
  const target = getConfigTarget(key);
  if (!target) return;
  if (target.getAttribute("data-config-hidden") === "true") return;

  const controls = target.matches("input, select, textarea")
    ? [target]
    : Array.from(target.querySelectorAll("input, select, textarea"));

  controls.forEach((el) => {
    el.setAttribute("data-config-locked", "true");
    el.setAttribute("aria-disabled", "true");

    if (el.tagName === "INPUT" || el.tagName === "TEXTAREA") {
      el.readOnly = true;
    }

    if (el.tagName === "SELECT") {
      const lockedValue = el.value;
      el.setAttribute("data-locked-value", lockedValue);
      el.tabIndex = -1;

      const keepLocked = () => {
        const v = el.getAttribute("data-locked-value");
        if (v !== null && el.value !== v) {
          el.value = v;
        }
      };

      if (!el.dataset.lockHandlersBound) {
        el.addEventListener("change", keepLocked);
        el.addEventListener("input", keepLocked);
        el.addEventListener("keydown", (evt) => {
          evt.preventDefault();
        });
        el.addEventListener("mousedown", (evt) => {
          evt.preventDefault();
        });
        el.dataset.lockHandlersBound = "true";
      }
    }
  });
});
}

function initPageConfig() {
  pageConfig = getRegistrationConfig();
}

function applyPageConfigToDom() {
  const headingEl = document.querySelector(".form-col h1");
  const subheadingEl = document.querySelector(".form-col .form-col_p");
  const heroImg = document.querySelector(".image-col img");

  if (headingEl && pageConfig.heading) headingEl.textContent = pageConfig.heading;
  if (subheadingEl && pageConfig.subheading) subheadingEl.textContent = pageConfig.subheading;

  if (heroImg) {
    if (pageConfig.heroImageUrl) heroImg.src = pageConfig.heroImageUrl;
    if (pageConfig.heroImageAlt) heroImg.alt = pageConfig.heroImageAlt;
  }
}

// ========= CONSENT GROUP (scoped to form) =========
const REQUIRED_CONSENTS = new Set(["consent-terms", "consent-privacy", "consent-MAP"]);
function getConsentInputByName(name) {
  return form?.querySelector(`input[type="checkbox"][name="${CSS.escape(name)}"]`);
}
function validateRequiredConsents({ paint = true } = {}) {
  const fs = form?.querySelector(".check_wrapper fieldset:first-of-type");
  let ok = true;
  REQUIRED_CONSENTS.forEach(name => {
    const el = getConsentInputByName(name);
    if (!el || !el.checked) ok = false;
  });
  if (paint && fs) {
    let msg = fs.querySelector(".error-msg");
    if (!ok) {
      fs.classList.add("field-error");
      if (!msg) {
        msg = document.createElement("small");
        msg.className = "error-msg";
        fs.appendChild(msg);
      }
      msg.textContent = "Please accept Terms, Privacy Policy, and MAP Agreement to continue.";
    } else {
      fs.classList.remove("field-error");
      if (msg) msg.remove();
    }
  }
  return ok;
}

// ========= CUSTOM RULES =========
const CUSTOM_RULES = {
  "npi-input": [
    {
      normalize: el => { el.value = el.value.replace(/\D/g, "").slice(0, 10); },
      when: el => (el.required && el.value.replace(/\D/g, "").length !== 10),
      message: "NPI must be exactly 10 digits."
    }
  ],
  "online": [
    {
      normalize: el => { el.value = el.value.trim(); },
      when: el => !!el.value && !/^https:\/\//i.test(el.value),
      message: "URL must start with https://"
    }
  ]
};

// ======== CERT UPLOAD RULES (JPG/PNG/PDF, <=5MB) ========
const MAX_FILE_SIZE = 5 * 1024 * 1024;
const ALLOWED_MIME = new Set(["image/jpeg", "image/png", "application/pdf"]);
const ALLOWED_EXT  = /\.(jpe?g|png|pdf)$/i;

CUSTOM_RULES["file"] = [
  {
    normalize: (el) => {
      const grp  = el.closest(".cert_wrapper") || form;
      const text = grp?.querySelector(".filetext");
      const over = grp?.querySelector(".validate__file--over");
      const f    = el.files && el.files[0];
      if (text) text.value = f ? (f.name || "") : "";
      if (over) over.hidden = true;
    },
    when: (el) => {
      const f = el.files && el.files[0];
      if (el.required && !f) return true;
      if (!f) return false;
      if (f.size > MAX_FILE_SIZE) {
        const grp  = el.closest(".cert_wrapper") || form;
        const over = grp?.querySelector(".validate__file--over");
        if (over) over.hidden = false;
        return true;
      }
      const typeOk = ALLOWED_MIME.has(f.type) || ALLOWED_EXT.test(f.name || "");
      return !typeOk;
    },
    message: (el) => {
      const f = el.files && el.files[0];
      if (!f) return "Please upload your certification document.";
      if (f.size > MAX_FILE_SIZE) return "File must be under 5MB in size.";
      return "Only JPG, PNG, or PDF files are allowed.";
    }
  }
];

// ========= CONTROL-LEVEL VALIDATION =========
function runCustomRules(el) {
  const id = el?.id || el?.name || "";
  const rules = CUSTOM_RULES[id];
  if (!rules) return null;
  for (const rule of rules) {
    try { if (rule.normalize) rule.normalize(el); } catch {}
    try {
      if (rule.when && rule.when(el)) {
        return typeof rule.message === "function" ? rule.message(el) : rule.message;
      }
    } catch {}
  }
  return null;
}
function runNativeMessages(el) {
  const v = el.validity || {};
  if (v.valueMissing)    return DEFAULT_MESSAGES.required(el);
  if (v.typeMismatch)    return (el.type === "email" ? DEFAULT_MESSAGES.email(el) : DEFAULT_MESSAGES.pattern(el));
  if (v.patternMismatch) return DEFAULT_MESSAGES.pattern(el);
  if (v.tooShort)        return DEFAULT_MESSAGES.minlength(el);
  if (el.tagName === "SELECT" && !el.value) return DEFAULT_MESSAGES.select(el);
  return null;
}
function validateControl(el, { paint = true } = {}) {
  if (!el) return true;
  if (!isInteractive(el)) {
    if (paint) clearFieldError(el);
    return true;
  }
  if (el.validity && el.validity.customError) {
    if (paint) setFieldError(el, el.validationMessage || "Please correct this field.");
    return false;
  }
  const customMsg = runCustomRules(el);
  if (customMsg) { if (paint) setFieldError(el, customMsg); return false; }
  if (!el.checkValidity()) { if (paint) setFieldError(el, runNativeMessages(el)); return false; }
  if (paint) clearFieldError(el);
  return true;
}

// ========= STRICT VALIDATION (used on Submit) =========
function validateControlStrict(el, { paint = true } = {}) {
  if (!el) return true;

  if (!isInteractive(el)) {
    if (paint) clearFieldError(el);
    return true;
  }

  const shouldCheck =
    (el.required || el.getAttribute("pattern") || el.minLength > 0 ||
     el.type === "email" || el.type === "tel" || el.type === "checkbox" || el.type === "radio" || el.type === "file");

  if (!shouldCheck) { if (paint) clearFieldError(el); return true; }

  const customMsg = runCustomRules(el);
  let ok;
  if (customMsg) {
    ok = false;
    if (paint) setFieldError(el, customMsg);
  } else if (!el.checkValidity()) {
    ok = false;
    if (paint) setFieldError(el, runNativeMessages(el));
  } else {
    ok = true;
    if (paint) clearFieldError(el);
  }
  return ok;
}

// ========= STEP VALIDATION =========
function validateStep(stepEl, { paint = true } = {}) {
  const controls = Array.from(stepEl.querySelectorAll("input, select, textarea"));
  let ok = true;

  const containsConsentGroup = !!stepEl.querySelector(".check_wrapper fieldset:first-of-type");

  for (const el of controls) {
    const needsCheck =
      !el.disabled &&
      (el.required || el.getAttribute("pattern") || el.minLength > 0 ||
       el.type === "email" || el.type === "tel" || el.type === "checkbox" || el.type === "radio" || el.type === "file");

    if (!needsCheck) { if (paint) clearFieldError(el); continue; }

    if (containsConsentGroup && el.type === "checkbox" && REQUIRED_CONSENTS.has(el.name)) {
      if (paint) clearFieldError(el);
      continue;
    }

    ok = (isInteractive(el) ? validateControl(el, { paint }) : true) && ok;
  }

  if (containsConsentGroup) ok = validateRequiredConsents({ paint }) && ok;
  return ok;
}

function validateAllStrict() {
  let ok = true;

  ok = validateRequiredConsents({ paint: true }) && ok;

  const controls = withinForm("input, select, textarea");
  for (const el of controls) {
    if (el.type === "checkbox" && REQUIRED_CONSENTS.has(el.name)) continue;

    if (!isInteractive(el)) { clearFieldError(el); continue; }

    ok = validateControlStrict(el, { paint: true }) && ok;
  }
  return ok;
}

// ========= ERROR FOCUS =========
function gotoFirstError(scope) {
  const root = scope || form || document;
  let firstErrControl = root.querySelector(".field-error input, .field-error select, .field-error textarea");
  if (firstErrControl) {
    const stepIndex = steps.findIndex(step => step.contains(firstErrControl));
    if (stepIndex >= 0) showStep(stepIndex);
    try { firstErrControl.focus({ preventScroll: true }); } catch {}
    firstErrControl.scrollIntoView({ behavior: "smooth", block: "center" });
    return;
  }
  const firstErrGroup = root.querySelector(".field-error");
  if (firstErrGroup) {
    const stepIndex = steps.findIndex(step => step.contains(firstErrGroup));
    if (stepIndex >= 0) showStep(stepIndex);
    const focusable = firstErrGroup.querySelector("input, select, textarea, button");
    try { focusable?.focus({ preventScroll: true }); } catch {}
    firstErrGroup.scrollIntoView({ behavior: "smooth", block: "center" });
  }
}

// ========= STEP NAV =========
function showStep(i) {
  steps.forEach((s, idx) => s.classList.toggle("active", idx === i));
  currentStep = i;
}

// ========= GLOBAL, SAFE NORMALIZERS =========
function normCountry(val) {
  const v = (val || "").trim().toLowerCase();
  if (
    [
      "united states",
      "united states of america",
      "us",
      "usa",
      "u.s.",
      "u.s.a."
    ].includes(v)
  ) return "us";
  if (["canada", "ca"].includes(v)) return "ca";
  if (
    [
      "united kingdom",
      "uk",
      "gb",
      "great britain",
      "england",
      "scotland",
      "wales",
      "northern ireland"
    ].includes(v)
  ) return "uk";
  if (["australia", "au"].includes(v)) return "au";
  return v;
}
function supportsStateField(countryValue) {
  const c = normCountry(countryValue);
  return c === "us" || c === "ca" || c === "uk" || c === "au";
}

function setPattern(el, cfg = {}) {
  if (!el) return;
  const { pattern, title, minLength } = cfg;
  if (pattern instanceof RegExp) el.setAttribute("pattern", pattern.source);
  else if (typeof pattern === "string" && pattern.length) el.setAttribute("pattern", pattern);
  else el.removeAttribute("pattern");

  if (title) el.setAttribute("title", title);
  else el.removeAttribute("title");
  if (typeof minLength === "number") el.minLength = minLength;
  el.setCustomValidity("");
}

let addressCtx = null;

function getLabelForControl(ctrl) {
  if (!ctrl) return null;
  if (ctrl.labels && ctrl.labels[0]) return ctrl.labels[0];
  const id = ctrl.id ? `label[for="${CSS.escape(ctrl.id)}"]` : null;
  const explicit = id ? (form?.querySelector(id) || ctrl.closest("div")?.querySelector(id)) : null;
  if (explicit) return explicit;
  return ctrl.closest("#state-group")?.querySelector("label") || ctrl.closest("div")?.querySelector("label") || null;
}
function setRequiredAsterisk(ctrl, required) {
  const label = getLabelForControl(ctrl);
  let star = label?.querySelector(".req-star");
  if (required) {
    if (!star) {
      star = document.createElement("span");
      star.className = "req-star";
      star.textContent = " *";
      label?.appendChild(star);
    }
    ctrl?.setAttribute("aria-required", "true");
  } else {
    if (star) star.remove();
    ctrl?.removeAttribute("aria-required");
  }
}

// UPDATED: syncAddress
function syncAddress() {
  if (!addressCtx) return;

  const { practice, groups, ctrls } = addressCtx;

  function SHOW(groupEl, controlEl, required = false) {
    groupEl.hidden = false;
    controlEl.disabled = false;
    controlEl.toggleAttribute("required", required);
    if (controlEl === ctrls.state) setRequiredAsterisk(controlEl, required);
  }
  function HIDE(groupEl, controlEl) {
    groupEl.hidden = true;
    controlEl.disabled = true;
    controlEl.required = false;
    controlEl.setCustomValidity("");
    clearFieldError(controlEl);
    if (controlEl === ctrls.state) setRequiredAsterisk(controlEl, false);
  }

  let pRaw = (practice?.value || "").trim().toLowerCase();
  pRaw = pRaw.replace(/\s+/g, " ").replace(/–/g, "-");
  let p = pRaw;
  if (pRaw === "in person") p = "in-person";
  if (pRaw === "virtual and in-person" || pRaw === "in-person and virtual") p = "in-person/virtual";

  const hasPractice = p === "in-person" || p === "in-person/virtual" || p === "virtual";

  HIDE(groups.country, ctrls.country);
  HIDE(groups.street, ctrls.street);
  HIDE(groups.city, ctrls.city);
  HIDE(groups.state, ctrls.state);
  HIDE(groups.zip, ctrls.zip);

  if (!hasPractice) {
    applyConfiguredRules();
    return;
  }

  SHOW(groups.country, ctrls.country, true);

  const c = normCountry(ctrls.country.value);
  const isUSCountry = c === "us";
  const stateAllowed = supportsStateField(ctrls.country.value);

  if (p === "in-person" || p === "in-person/virtual") {
    if (isUSCountry) {
      SHOW(groups.street, ctrls.street, true);
      SHOW(groups.city, ctrls.city, true);
      SHOW(groups.zip, ctrls.zip, true);
      SHOW(groups.state, ctrls.state, true);
    } else {
      SHOW(groups.street, ctrls.street, true);
      SHOW(groups.city, ctrls.city, true);
      if (stateAllowed) SHOW(groups.state, ctrls.state, false);
    }
  } else if (p === "virtual") {
    if (isUSCountry) {
      SHOW(groups.zip, ctrls.zip, true);
      SHOW(groups.state, ctrls.state, true);
    } else {
      SHOW(groups.city, ctrls.city, true);
      if (stateAllowed) SHOW(groups.state, ctrls.state, false);
    }
  }

  applyCountryConstraints();
  applyConfiguredRules();
}

function applyCountryConstraints() {
  if (!addressCtx) return;
  const { ctrls, groups } = addressCtx;
  const c = normCountry(ctrls.country?.value);

  let zip = {
    pattern: "^[A-Za-z0-9\\- ]{3,10}$",
    title: "3–10 letters/numbers"
  };

  if (c === "us") {
    zip = {
      pattern: "^\\d{5}(?:-\\d{4})?$",
      title: "ZIP 5 or ZIP+4 (e.g., 12345 or 12345-6789)"
    };
    ctrls.zip.placeholder = "e.g., 12345 or 12345-6789";
    ctrls.state.placeholder = "e.g., CA";
    setPattern(ctrls.state, {
      pattern: "^(A[KLRZ]|C[AOT]|D[CE]|FL|GA|HI|I[ADLN]|K[SY]|LA|M[ADEINOST]|N[CDEHJMVY]|O[HKR]|P[AR]|RI|S[CD]|T[NX]|UT|V[AIT]|W[AIVY])$",
      title: "Use 2-letter state code (e.g., CA, NY)"
    });
  } else if (c === "ca") {
    zip = {
      pattern: "^[ABCEGHJ-NPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z][ ]?\\d[ABCEGHJ-NPRSTV-Z]\\d$",
      title: "Canadian format (e.g., K1A 0B1)"
    };
    ctrls.zip.placeholder = "e.g., K1A 0B1";
    ctrls.state.placeholder = "e.g., ON";
    setPattern(ctrls.state, {
      pattern: "^(AB|BC|MB|NB|NL|NS|NT|NU|ON|PE|QC|SK|YT)$",
      title: "Use province/territory code (e.g., ON, BC)"
    });
  } else if (c === "uk") {
    zip = {
      pattern: "^([A-Z]{1,2}\\d[A-Z\\d]?\\s*\\d[A-Z]{2})$",
      title: "UK postcode (e.g., SW1A 1AA)"
    };
    ctrls.zip.placeholder = "e.g., SW1A 1AA";
    setPattern(ctrls.state, { pattern: "", title: "County/Region (optional)" });
  } else if (c === "au") {
    zip = { pattern: "^\\d{4}$", title: "4-digit postcode (e.g., 2000)" };
    ctrls.zip.placeholder = "e.g., 2000";
    ctrls.state.placeholder = "e.g., NSW";
    setPattern(ctrls.state, {
      pattern: "^(ACT|NSW|NT|QLD|SA|TAS|VIC|WA)$",
      title: "Use state/territory code (e.g., NSW, VIC)"
    });
  } else {
    setPattern(ctrls.state, { pattern: "", title: "State/Province/Region" });
    groups.state.hidden = true;
    ctrls.state.disabled = true;
    ctrls.state.required = false;
    clearFieldError(ctrls.state);
    setRequiredAsterisk(ctrls.state, false);
    ctrls.zip.placeholder = "Postal code";
  }

  const cityPattern = "^[A-Za-z .,'-]{2,100}$";
  const streetPattern = "^[A-Za-z0-9 .,'#\\-/]{3}$";

  setPattern(ctrls.zip, zip);
  setPattern(ctrls.city, {
    pattern: cityPattern,
    title: "At least 2 letters; letters, spaces, and - . , ' allowed"
  });
  setPattern(ctrls.street, {
    minLength: 3,
    pattern: streetPattern,
    title: "At least 3 characters; numbers/letters allowed"
  });
}

window.syncAddress = syncAddress;

// ========= NPI TOGGLING =========
let npiCtx = null;
function syncNpi() {
  if (!npiCtx) return;
  const {
    npiSelect, npiGroup, npiInp, profGroup, profSelect,
    certGroup, certInput, certFileText, certOverMsg, certReqBadge
  } = npiCtx;

  const raw = (npiSelect?.value || "");
  const val = raw.toLowerCase().replace(/\s+/g, "");

  function setGroup(groupEl, controlEl, showIt, makeRequired = false) {
    if (!groupEl || !controlEl) return;
    groupEl.hidden = !showIt;
    controlEl.disabled = !showIt;
    controlEl.required = !!makeRequired;

    if (!showIt) {
      if (controlEl.type === "file") {
        try { controlEl.value = ""; } catch {}
        if (certFileText) certFileText.value = "";
        if (certOverMsg) certOverMsg.hidden = true;
      } else {
        controlEl.value = "";
      }
      controlEl.setCustomValidity("");
      clearFieldError(controlEl);
    }
  }

  setGroup(npiGroup, npiInp, val === "yes", true);
  setGroup(profGroup, profSelect, val === "no", true);

  const showCert = (val === "no");
  setGroup(certGroup, certInput, showCert, showCert);
  if (certReqBadge) certReqBadge.textContent = showCert ? "(Required)" : "(Optional)";

  applyConfiguredRules();
}
window.syncNpi = syncNpi;

// ========= INIT =========
onReady(() => {
  try {
    form = document.getElementById("pro-registration");
    if (!form) return;

    initPageConfig();
    applyPageConfigToDom();
    validateOnline();

    steps = withinForm(".form-step");
    nextBtns = withinForm(".next");
    prevBtns = withinForm(".prev");

    function validateOnline() {
      const onlineEl = form.querySelector("#online");
      if (!onlineEl) return;

      onlineEl.removeAttribute("pattern");

      function isIPv4(host) {
        if (!/^\d{1,3}(\.\d{1,3}){3}$/.test(host)) return false;
        return host.split(".").every(p => {
          const n = Number(p);
          return Number.isInteger(n) && n >= 0 && n <= 255;
        });
      }

      function isIPv6(host) {
        return host.includes(":") && /^[0-9a-f:]+$/i.test(host);
      }

      function isValidDomain(host) {
        if (!host) return false;
        if (host.length > 253) return false;
        if (host.endsWith(".")) return false;
        if (!host.includes(".")) return false;

        const labels = host.split(".").filter(Boolean);
        if (labels.length < 2) return false;

        const tld = labels[labels.length - 1];
        const tldOk =
          /^[a-z]{2,63}$/i.test(tld) ||
          /^xn--[a-z0-9-]{2,59}$/i.test(tld);
        if (!tldOk) return false;

        for (const label of labels) {
          if (label.length < 1 || label.length > 63) return false;
          if (!/^[a-z0-9-]+$/i.test(label)) return false;
          if (label.startsWith("-") || label.endsWith("-")) return false;
        }

        return true;
      }

      CUSTOM_RULES["online"] = [
        {
          normalize: (el) => { el.value = (el.value || "").trim(); },
          when: (el) => {
            const v = (el.value || "").trim();
            if (!v) return false;
            if (!/^https:\/\//i.test(v)) return true;
            if (/^https:\/\/\/*$/i.test(v)) return true;

            try {
              const u = new URL(v);

              if (u.protocol !== "https:") return true;
              if (u.username || u.password) return true;

              const host = (u.hostname || "").toLowerCase();
              if (!host) return true;

              if (isIPv4(host) || isIPv6(host)) return true;
              if (host === "localhost") return true;
              if (!isValidDomain(host)) return true;

              return false;
            } catch {
              return true;
            }
          },
          message: (el) =>
            el?.dataset?.msgPattern ||
            "Enter a valid https:// website (e.g., https://example.com)"
        }
      ];

      let touched = false;
      const run = () => validateControl(onlineEl, { paint: touched });
      onlineEl.addEventListener("input", run);
      onlineEl.addEventListener("change", run);
      onlineEl.addEventListener("blur", () => { touched = true; run(); });
    }

    // -------- Practice / Address context wires --------
    const practice = form.querySelector("#practice-type");
    const country = form.querySelector("#country");
    addressCtx = {
      practice,
      groups: {
        country: form.querySelector("#country-group"),
        street: form.querySelector("#street-group"),
        city: form.querySelector("#city-group"),
        state: form.querySelector("#state-group"),
        zip: form.querySelector("#zip-group")
      },
      ctrls: {
        country,
        street: form.querySelector("#street"),
        city: form.querySelector("#city"),
        state: form.querySelector("#state"),
        zip: form.querySelector("#zip")
      }
    };
    practice?.addEventListener("change", syncAddress);
    country?.addEventListener("input", syncAddress);
    country?.addEventListener("change", syncAddress);
    applyCountryConstraints();
    syncAddress();

    const addr = addressCtx.ctrls;
    function attachAddressLive(el, debounceMs = 200) {
      if (!el) return;
      let t; let touched = false;
      const run = () => {
        if (!el.value.trim() && !touched) { el.setCustomValidity(""); clearFieldError(el); return; }
        validateControl(el, { paint: true });
      };
      const d = () => { clearTimeout(t); t = setTimeout(run, debounceMs); };
      el.addEventListener("input", d);
      el.addEventListener("change", run);
      el.addEventListener("blur", () => { touched = true; run(); });
    }
    attachAddressLive(addr.street);
    attachAddressLive(addr.city);
    attachAddressLive(addr.state);
    attachAddressLive(addr.zip);
    country?.addEventListener("input", applyCountryConstraints);
    country?.addEventListener("change", applyCountryConstraints);

    // -------- NPI wires --------
    npiCtx = {
      npiSelect: form.querySelector("#npi"),
      npiGroup: form.querySelector("#npi-number-group"),
      npiInp: form.querySelector("#npi-input"),
      profGroup: form.querySelector("#profession-group"),
      profSelect: form.querySelector("#profession"),
      certGroup: form.querySelector("#cert-group"),
      certInput: form.querySelector("#file"),
      certFileText: form.querySelector(".filetext"),
      certOverMsg: form.querySelector(".validate__file--over"),
      certReqBadge: form.querySelector("[data-check-input='file']")
    };
    npiCtx.npiSelect?.addEventListener("change", syncNpi);
    syncNpi();

    // -------- Source wires --------
    let sourceCtx = {
      sourceSelect: form.querySelector("#source"),
      sourceGroup: form.querySelector(".source_wrapper"),
      sourceDescriptionInput: form.querySelector("#source_description"),
      sourceDescriptionGroup: form.querySelector("#source_description_group"),
      sourceDescriptionLabel: form.querySelector("label[for='source_description']")
    };

    if (pageConfig.sourceDefault && sourceCtx.sourceSelect) {
      sourceCtx.sourceSelect.value = pageConfig.sourceDefault;
    }

    if (pageConfig.sourceDescriptionDefault && sourceCtx.sourceDescriptionInput) {
      sourceCtx.sourceDescriptionInput.value = pageConfig.sourceDescriptionDefault;
    }

    const brandsEl = form.querySelector("#brands");
    if (pageConfig.brandDefault && brandsEl) {
      brandsEl.value = pageConfig.brandDefault;
    }

    function syncSource() {
      if (!sourceCtx) return;
      const { sourceSelect, sourceDescriptionInput, sourceDescriptionGroup, sourceDescriptionLabel } = sourceCtx;

      const v = (sourceSelect?.value || "").trim();

      const needDescFor = new Map([
        ["Practitioner / Colleague", "Referring Practitioner Name*"],
        ["Sales Representative", "Sales Rep Name*"],
        ["Tradeshow / Event", "Event Name*"]
      ]);

      const labelText = needDescFor.get(v);
      const show = !!labelText;

      if (sourceDescriptionGroup) sourceDescriptionGroup.hidden = !show;
      if (sourceDescriptionInput) {
        sourceDescriptionInput.disabled = !show;
        sourceDescriptionInput.required = show;

        if (!show) {
          sourceDescriptionInput.value = "";
          sourceDescriptionInput.setCustomValidity("");
          clearFieldError(sourceDescriptionInput);
        }
      }
      if (sourceDescriptionLabel) {
        sourceDescriptionLabel.textContent = labelText || "Details";
      }

      applyConfiguredRules();
    }

    sourceCtx.sourceSelect?.addEventListener("change", () => {
      syncSource();
      sourceCtx.sourceSelect.dataset.touched = "true";
      validateControl(sourceCtx.sourceSelect, { paint: true });
    });
    syncSource();

    // -------- Phone flags & validation --------
    const phoneEl = form.querySelector("#phone");
    const mobileEl = form.querySelector("#mobile");

    const smsConsentWrapper = form.querySelector("#sms-consent-wrapper");
    const smsConsentInput = form.querySelector('input[name="consent-sms"]');

    function syncSmsConsentVisibility() {
    const hasMobile = !!mobileEl?.value.trim();

    if (smsConsentWrapper) smsConsentWrapper.hidden = !hasMobile;

    if (!hasMobile && smsConsentInput) {
        smsConsentInput.checked = false;
        smsConsentInput.required = false;
        clearFieldError(smsConsentInput);
    }
    }

    mobileEl?.addEventListener("input", syncSmsConsentVisibility);
    mobileEl?.addEventListener("change", syncSmsConsentVisibility);
    syncSmsConsentVisibility();

    function attachPhone(el) {
      if (!el) return null;
      el.dataset.touched = "false";
      let inst = null;

      if (typeof window.intlTelInput === "function") {
        inst = window.intlTelInput(el, {
          utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@17.0.3/build/js/utils.js",
          nationalMode: false,
          allowDropdown: true,
          separateDialCode: true,
          initialCountry: "us",
          preferredCountries: ["us", "ca", "gb", "au", "nz"],
          autoPlaceholder: "polite",
          formatOnDisplay: true
        });
      }

      const updateValidity = () => {
        if (!el.value.trim()) { el.setCustomValidity(""); return; }
        if (inst && typeof inst.isValidNumber === "function") {
          el.setCustomValidity(inst.isValidNumber() ? "" : "Not a valid Phone Number");
        } else {
          const min = el.minLength || 6;
          el.setCustomValidity(el.value.replace(/\D/g, "").length >= min ? "" : "Not a valid Phone Number");
        }
      };

      el.addEventListener("input", () => {
        updateValidity();
        if (el.dataset.touched === "true") validateControl(el, { paint: true });
      });
      el.addEventListener("blur", () => {
        el.dataset.touched = "true";
        updateValidity();
        validateControl(el, { paint: true });
      });
      el.addEventListener("countrychange", () => {
        updateValidity();
        if (el.dataset.touched === "true") validateControl(el, { paint: true });
      });

      if (el.value.trim()) updateValidity();
      try { inst?.promise?.then(() => { if (el.value.trim()) el.dispatchEvent(new Event("input")); }); } catch {}
      if (inst) phoneInstances.set(el, inst);
      return inst;
    }
    (function initPhones(tries = 0) {
      if (typeof window.intlTelInput !== "function") {
        if (tries < 200) return void setTimeout(() => initPhones(tries + 1), 50);
      }
      attachPhone(phoneEl);
      attachPhone(mobileEl);
    })();

    // -------- Async Email Check --------
    const emailInput = form.querySelector("#email");
    const emailFoundMsgEl = form.querySelector(".email-found[data-email='message']");
    function debounce(fn, wait = 450) {
      let t;
      return (...args) => { clearTimeout(t); t = setTimeout(() => fn.apply(null, args), wait); };
    }
    let emailAbortController = null;
    async function checkEmailExists(value) {
      if (emailAbortController) emailAbortController.abort();
      emailAbortController = new AbortController();
      const url = `https://admin.cellcorebiosciences.com/api/auth0/user.get?email=${encodeURIComponent(value)}`;
      const res = await fetch(url, { signal: emailAbortController.signal });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.json();
    }
    const validateEmailLive = debounce(async (e) => {
      const el = e.target;
      try {
        if (!el.value.trim()) {
          if (emailFoundMsgEl) emailFoundMsgEl.dataset.showLive = "false";
          validateControl(el, { paint: !!el.dataset.touched });
          return;
        }

        if (!el.checkValidity() && el.validity.typeMismatch) {
          el.setCustomValidity("Please enter a valid email address.");
          if (emailFoundMsgEl) emailFoundMsgEl.dataset.showLive = "false";
          validateControl(el, { paint: !!el.dataset.touched });
          return;
        }

        el.classList.add("pending");
        let result = null;
        try { result = await checkEmailExists(el.value.trim()); }
        finally { el.classList.remove("pending"); }

        if (result?.email) {
          el.setCustomValidity("This email has already been registered with us");
          if (emailFoundMsgEl) emailFoundMsgEl.dataset.showLive = "true";
        } else if (result && result.status === "failed" && /email/i.test(result.message || "")) {
          el.setCustomValidity("Please enter a valid email address.");
          if (emailFoundMsgEl) emailFoundMsgEl.dataset.showLive = "false";
        } else {
          el.setCustomValidity("");
          if (emailFoundMsgEl) emailFoundMsgEl.dataset.showLive = "false";
        }
        validateControl(el, { paint: !!el.dataset.touched });
      } catch {
        el.classList.remove("pending");
        if (emailFoundMsgEl) emailFoundMsgEl.dataset.showLive = "false";
      }
    }, 450);
    if (emailInput) {
      emailInput.addEventListener("input", validateEmailLive);
      emailInput.addEventListener("blur", (e) => {
        e.target.dataset.touched = "true";
        validateEmailLive(e);
      });
    }

    // -------- Certificate Upload wires --------
    const certFileInput = form.querySelector("#file");
    const certBtn = form.querySelector("#cert-filebtn");
    if (certBtn && certFileInput) {
      certBtn.addEventListener("click", () => certFileInput.click());
    }
    if (certFileInput) {
      certFileInput.addEventListener("change", () => {
        validateControl(certFileInput, { paint: true });
      });
    }

    // -------- Realtime generic validation --------
    form.addEventListener("input", e => {
      const t = e.target;
      if (t && t.matches("input, select, textarea") && t.type !== "tel") {
        validateControl(t, { paint: !!t.dataset.touched });
      }
    });
    form.addEventListener("blur", e => {
      const t = e.target;
      if (t && t.matches("input, select, textarea") && t.type !== "tel") {
        t.dataset.touched = "true";
        validateControl(t, { paint: true });
      }
    }, true);
    form.addEventListener("change", e => {
      const t = e.target;
      if (!t) return;
      if (t.type === "checkbox" && REQUIRED_CONSENTS.has(t.name)) {
        validateRequiredConsents({ paint: true });
        return;
      }
      if (t.matches("select, input[type='checkbox'], input[type='radio']")) {
        t.dataset.touched = "true";
        validateControl(t, { paint: true });
      } else if (t.matches("input, textarea") && t.type !== "tel") {
        validateControl(t, { paint: !!t.dataset.touched });
      }
    });

    // -------- NAV HANDLERS --------
    function firstFocusableIn(stepEl) {
      return stepEl.querySelector("input, select, textarea, button");
    }
    nextBtns.forEach(btn => {
      btn.disabled = false;
      btn.addEventListener("click", () => {
        const step = steps[currentStep];
        syncNpi();
        syncAddress();
        applyConfiguredRules();
        const ok = validateStep(step, { paint: true });
        if (!ok) { gotoFirstError(step); return; }
        if (currentStep < steps.length - 1) {
          showStep(currentStep + 1);
          const first = firstFocusableIn(steps[currentStep]); first?.focus();
        }
      });
    });
    prevBtns.forEach(btn => {
      btn.disabled = false;
      btn.addEventListener("click", () => {
        if (currentStep > 0) {
          showStep(currentStep - 1);
          const first = firstFocusableIn(steps[currentStep]); first?.focus();
        }
      });
    });

    // -------- Apply config rules once initial dynamic logic is ready --------
    applyConfiguredRules();

    // -------- SUBMIT HANDLER --------
    form.setAttribute("novalidate", "novalidate");
    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      try {
        syncNpi();
        syncAddress();
        applyConfiguredRules();
      } catch {}

      const ok = validateAllStrict();

      if (!ok) {
        const bad = form.querySelector(".field-error input, .field-error select, .field-error textarea");
        console.log("BLOCKED BY:", bad ? {
          id: bad.id, name: bad.name, type: bad.type,
          step: steps.findIndex(s => s.contains(bad)),
          value: bad.value
        } : "no .field-error found");
        gotoFirstError(form);
        return;
      }

      const submitBtn = form.querySelector(".submit");
      const alertBox = document.getElementById("form-alert");
      const successBox = document.getElementById("form-success");
      const emailMsg = form.querySelector(".email-found[data-email='message']");

      const showAlert = (msg) => {
        if (successBox) successBox.style.display = "none";
        if (alertBox) {
          alertBox.textContent = msg;
          alertBox.style.display = "block";
          alertBox.style.color = "#d92d20";
        }
      };

      const phoneEl = form.querySelector("#phone");
      const mobileEl = form.querySelector("#mobile");
      const phoneIti = phoneInstances.get(phoneEl);
      const mobIti = phoneInstances.get(mobileEl);
      const toE164 = (inst, el) =>
        (inst && typeof inst.getNumber === "function")
          ? (inst.getNumber() || (el?.value?.trim() || ""))
          : (el?.value?.trim() || "");

      const getVal = (sel) => form.querySelector(sel)?.value?.trim() || "";
      const checked = (name) => form.querySelector(`input[type="checkbox"][name="${CSS.escape(name)}"]`)?.checked || false;

      const npiChoice = getVal("#npi");
      const npiNumber = getVal("#npi-input");
      const profession = getVal("#profession");
      const practiceType = getVal("#practice-type");
      const country = getVal("#country");
      const stateCode = getVal("#state");
      const stateFull = codeToFullState(country, stateCode);
      const city = getVal("#city");
      const street = getVal("#street");
      const zip = getVal("#zip");

      const fd = new FormData();
      const appendIf = (k, v) => {
        if (v !== null && v !== undefined && v !== "") fd.append(k, v);
      };
      const appendBool = (k, b) => fd.append(k, b ? "true" : "false");

      appendIf("campaign_code", pageConfig.campaignCode || "");
      
      appendIf("tags", pageConfig.tags.join(","));

      appendIf("email", getVal("#email"));
      appendIf("prefix", getVal("#prefix"));
      appendIf("first_name", getVal("#first-name"));
      appendIf("last_name", getVal("#last-name"));
      appendIf("phone", toE164(phoneIti, phoneEl));
      appendIf("practice_name", getVal("#business"));
      appendBool("marketing_email_opt_in", checked("consent-email"));
      appendBool("marketing_sms_opt_in", checked("consent-sms"));

      appendIf("mobile", toE164(mobIti, mobileEl));
      appendIf("website", getVal("#online"));
      appendIf("brand_interest", getVal("#brands"));
      appendIf("avg_patients_per_month", getVal("#avg-patients"));
      appendIf("practitioners_in_clinic", getVal("#num-practitioners"));
      appendIf("interest_level", getVal("#interest"));
      appendIf("supplement_vendor", getVal("#supplement"));
      appendIf("source", getVal("#source"));
      appendIf("source_description", getVal("#source_description"));

      appendBool("npi_has_number", (npiChoice.toLowerCase() === "yes"));
      if (npiChoice.toLowerCase().replace(/\s+/g, "") === "yes") {
        appendIf("npi_number", npiNumber);
      } else if (npiChoice.toLowerCase().replace(/\s+/g, "") === "no") {
        appendIf("profession", profession);
      }

      appendIf("practice_type", practiceType);
      appendIf("country", country);
      appendIf("state", stateFull);
      appendIf("city", city);
      appendIf("street", street);
      appendIf("zip", zip);

      appendBool("consent_terms", checked("consent-terms"));
      appendBool("consent_privacy", checked("consent-privacy"));
      appendBool("consent_map", checked("consent-MAP"));
      appendBool("find_prac_opt_in", checked("consent-findpro"));

      const certInput = form.querySelector("#file");
      const file = certInput?.files?.[0] || null;
      if (file) {
        const fieldName = certInput.getAttribute("name") || "file";
        fd.append(fieldName, file, file.name);
      }

      const API_URL = "https://cellcore-node-admin.azurewebsites.net/api/practitioner/register?code=IzT6yDJN65O8qN-KiJp8aAS0FduyJr6-v2qE7DXs6euhAzFusp0sPw==";
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 20000);

      const prevLabel = submitBtn?.textContent;
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = "Submitting…"; }

      try {
        const res = await fetch(API_URL, {
          method: "POST",
          body: fd,
          redirect: "follow",
          signal: controller.signal
        });
        clearTimeout(timeoutId);

        if (res.ok) {
          window.location.replace(pageConfig.successRedirectUrl || DEFAULT_REGISTRATION_CONFIG.successRedirectUrl);
          return;
        }

        let result = null;
        try { result = await res.clone().json(); } catch { try { result = await res.text(); } catch {} }

        if (res.status === 409) {
          if (emailMsg) emailMsg.dataset.showLive = "true";
          setFieldError(form.querySelector("#email"), "This email has already been registered with us");
          gotoFirstError(form);
          showAlert("An account with this email already exists. Please log in.");
          return;
        }
        if (res.status === 400) {
          showAlert(typeof result === "string" ? result : "Some information looks invalid. Please review the highlighted fields.");
          gotoFirstError(form);
          return;
        }

        showAlert(`We couldn't complete your registration (HTTP ${res.status}). Please try again.`);
      } catch (err) {
        showAlert("Network error submitting your application. Please check your connection and try again.");
      } finally {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = prevLabel || "Submit"; }
      }
    });

    showStep(currentStep);
    withinForm(".next, .submit").forEach(b => b.disabled = false);

  } catch (err) {
    try {
      const fallbackForm = document.getElementById("pro-registration");
      if (fallbackForm) {
        fallbackForm.addEventListener("submit", (e) => {
          e.preventDefault();
          alert("Please complete all required fields.");
        }, { once: true });
      }
    } catch {}
    console.error("Registration form initialization error:", err);
  }
});
} catch(error){console.error(error);}